var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("h1", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("menu.tracking_data")))
    ]),
    _c(
      "div",
      { staticClass: "columns" },
      _vm._l(_vm.trackingBlocks, function(tracking) {
        return _c("div", { key: tracking.type, staticClass: "column" }, [
          _c("div", { staticClass: "card card-delete" }, [
            _c("div", { staticClass: "card-content" }, [
              _c(
                "p",
                { staticClass: "title is-size-4 has-text-centered pb-3" },
                [_vm._v(" " + _vm._s(tracking.title) + " ")]
              ),
              _c(
                "ul",
                { staticClass: "subtitle has-text-white list-style-disc ml-4" },
                _vm._l(tracking.description, function(content) {
                  return _c("li", { key: content, staticClass: "is-size-6" }, [
                    _vm._v(" " + _vm._s(content) + " ")
                  ])
                }),
                0
              )
            ]),
            _c("footer", { staticClass: "card-footer is-danger" }, [
              _c(
                "p",
                {
                  staticClass: "card-footer-item",
                  on: {
                    click: function($event) {
                      return _vm.deleteTrackingData(tracking.type)
                    }
                  }
                },
                [
                  _c("b-icon", {
                    staticClass: "mr-2",
                    attrs: { icon: "delete" }
                  }),
                  _vm._v(" " + _vm._s(_vm.$t("delete")) + " ")
                ],
                1
              )
            ])
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }